import BtnWhatsapp from "../btnWhatsapp/BtnWhatsapp";
import Footer from "../footer/Footer";
import Nav from "../nav/Nav";
import "./QuienesSomos.css";

const QuienesSomos = () => {
  return (
    <>
      <Nav />
      <div className="quienes-somos">
        <h2>Quiénes Somos – TecniPlus+</h2>
        <p>
          En TecniPlus+ nos especializamos en brindar soluciones rápidas,
          confiables y de calidad para todo tipo de celulares. Nacimos con el
          objetivo de ofrecer un servicio técnico profesional, transparente y
          accesible, pensado para quienes necesitan reparar su dispositivo sin
          complicaciones.
        </p>
        <p>
          Contamos con experiencia en diagnóstico, reparación y mantenimiento de
          equipos, trabajando con repuestos de calidad y herramientas adecuadas
          para garantizar resultados duraderos. Sabemos lo importante que es tu
          celular en el día a día, por eso nos enfocamos en tiempos de entrega
          ágiles y atención personalizada en cada caso.
        </p>
        <p>
          Nuestro compromiso es claro: ofrecer un servicio honesto, explicar
          cada reparación de forma sencilla y asegurarnos de que cada cliente se
          vaya conforme.
        </p>
        <p>En TecniPlus+, tu celular está en buenas manos.</p>
      </div>
      <Footer />
      <BtnWhatsapp />
    </>
  );
};

export default QuienesSomos;
